import { render } from "./HelpSearch.vue?vue&type=template&id=2906993f&scoped=true"
import script from "./HelpSearch.vue?vue&type=script&lang=js"
export * from "./HelpSearch.vue?vue&type=script&lang=js"

import "./HelpSearch.vue?vue&type=style&index=0&id=2906993f&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2906993f"]])

export default __exports__